import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { V2021_1KartePlannerCommentMonthlyAmountFragmentDoc } from './KartePlannerCommentMonthlyAmountV20211.generated';
import { V2022_1KartePlannerCommentMonthlyAmountFragmentDoc } from './KartePlannerCommentMonthlyAmountV20221.generated';
import { V2023_1KartePlannerCommentMonthlyAmountFragmentDoc } from './KartePlannerCommentMonthlyAmountV20231.generated';
export type KartePlannerCommentMonthlyAmount_ManageOnlyFreePlanKartePlannerCommentMonthlyAmount_Fragment = { __typename: 'ManageOnlyFreePlanKartePlannerCommentMonthlyAmount' };

export type KartePlannerCommentMonthlyAmount_V2021_1KartePlannerCommentMonthlyAmount_Fragment = { __typename: 'V2021_1KartePlannerCommentMonthlyAmount', items: Array<{ __typename?: 'V2021_1KartePlannerCommentMonthlyAmountItem', channel: Types.Channel, usage: number, upperLimit?: number | null }> };

export type KartePlannerCommentMonthlyAmount_V2022_1KartePlannerCommentMonthlyAmount_Fragment = { __typename: 'V2022_1KartePlannerCommentMonthlyAmount', usage: number, upperLimit?: number | null };

export type KartePlannerCommentMonthlyAmount_V2023_1KartePlannerCommentMonthlyAmount_Fragment = { __typename: 'V2023_1KartePlannerCommentMonthlyAmount', usage: number, upperLimit?: number | null };

export type KartePlannerCommentMonthlyAmountFragment = KartePlannerCommentMonthlyAmount_ManageOnlyFreePlanKartePlannerCommentMonthlyAmount_Fragment | KartePlannerCommentMonthlyAmount_V2021_1KartePlannerCommentMonthlyAmount_Fragment | KartePlannerCommentMonthlyAmount_V2022_1KartePlannerCommentMonthlyAmount_Fragment | KartePlannerCommentMonthlyAmount_V2023_1KartePlannerCommentMonthlyAmount_Fragment;

export const KartePlannerCommentMonthlyAmountFragmentDoc = gql`
    fragment KartePlannerCommentMonthlyAmount on KartePlannerCommentMonthlyAmount {
  __typename
  ... on V2021_1KartePlannerCommentMonthlyAmount {
    ...V2021_1KartePlannerCommentMonthlyAmount
  }
  ... on V2022_1KartePlannerCommentMonthlyAmount {
    ...V2022_1KartePlannerCommentMonthlyAmount
    usage
  }
  ... on V2023_1KartePlannerCommentMonthlyAmount {
    ...V2023_1KartePlannerCommentMonthlyAmount
    usage
  }
}
    ${V2021_1KartePlannerCommentMonthlyAmountFragmentDoc}
${V2022_1KartePlannerCommentMonthlyAmountFragmentDoc}
${V2023_1KartePlannerCommentMonthlyAmountFragmentDoc}`;